"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[9275],{

/***/ 6978
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class B2bCollectionItemController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = [
    'addProductButton',
    'removeProductButton',
    'quantityControl',
    'buttonFeedback',
    'quantityInCart',
  ]

  static values = {
    sku: String,
    quantity: Number,
    productVariantId: Number,
  }

  static outlets = ['b2b-collection']

  async addProduct(event) {
    event.preventDefault()

    this.disableButtonsWithMessage('Adding to cart...')

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          { quantity: 10, id: this.productVariantIdValue }
        ],
      })
    });

    if (response.ok) {
      this.buttonFeedbackTarget.textContent = 'Added to cart!'
      this.quantityValue = this.quantityValue + 10
    } else {
      this.buttonFeedbackTarget.textContent = 'Error, try again'
    }

    this.b2bCollectionOutlet.updateCheckoutPrice()

    setTimeout(() => {
      this.quantityInCartTarget.textContent = `${this.quantityValue} in cart`
      this.enableButtons()
    }, 1000)
  }

  async removeProduct(event) {
    event.preventDefault()

    this.disableButtonsWithMessage('Removing from cart...')

    const newQuantity = this.quantityValue < 10 ? 0 : this.quantityValue - 10

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [this.productVariantIdValue]: newQuantity
        },
      })
    });

    if (response.ok) {
      this.buttonFeedbackTarget.textContent = 'Removed from cart!'
      this.quantityValue = newQuantity
    } else {
      this.buttonFeedbackTarget.textContent = 'Error, try again'
    }

    this.b2bCollectionOutlet.updateCheckoutPrice()

    setTimeout(() => {
      this.quantityInCartTarget.textContent = `${newQuantity} in cart`
      this.enableButtons()
    }, 1000)
  }

  disableButtonsWithMessage(message) {
    this.addProductButtonTarget.disabled = true
    this.removeProductButtonTarget.disabled = true
    this.buttonFeedbackTarget.textContent = message
    this.buttonFeedbackTarget.classList.remove('hidden')
    this.quantityControlTarget.classList.add('hidden')
  }

  updateRemoveButton() {
    if (this.quantityValue > 0) {
      this.removeProductButtonTarget.disabled = false
      this.removeProductButtonTarget.textContent = `- ${this.quantityValue > 10 ? 10 : this.quantityValue}`
    } else {
      this.removeProductButtonTarget.disabled = true
      this.removeProductButtonTarget.textContent = ''
    }
  }

  enableButtons() {
    this.updateRemoveButton()
    this.addProductButtonTarget.disabled = false
    this.removeProductButtonTarget.disabled = false
    this.buttonFeedbackTarget.classList.add('hidden')
    this.quantityControlTarget.classList.remove('hidden')
  }

  checkIfAvailable(availableSkus) {
    if (!availableSkus.includes(this.skuValue)) {
      this.markAsOutOfStock()
    }
  }

  markAsOutOfStock() {
    this.element.classList.add('oos')
    this.disableButtonsWithMessage("Out of stock")
  }
}

Stimulus.register('b2b-collection-item', B2bCollectionItemController)


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(6978)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);